import { timesaveTemplateQuestionApi } from '@services/Wj/Template';
import { timesaveSurveryQuestionApi } from '@services/Wj/Question';

/**
 * 保存单题题干（timesave），供题干 RichEditor 防抖/blur 共用。
 * route 丢失时根据 pathname 兜底，避免刷新后 state 不全导致「永远不保存」。
 */
export async function saveQuestionStemBody({ item, nextBody, anserArea, locationState, pathname }) {
    const resArr = [...anserArea];
    const index = resArr.findIndex(it => it.id === item.id);
    if (index < 0) {
        console.warn('题干保存：未找到题目', item.id);
        return false;
    }
    resArr[index] = {
        ...resArr[index],
        templateId: locationState?.id,
        body: nextBody,
    };
    // 禁止在请求前修改 item.body：失败时 remoteBody 若被提前改掉，useQuestionStemAutosave 会把 lastOkRef
    // 同步成「仅前端内存里的新值」，导致误判已落库而跳过后续保存。仅在接口成功后再与父级数据对齐。

    const route = locationState?.route;
    let useTemplate = route === 'newCreate';
    let useSurvey = route === 'newList' || route === 'newTemplate';

    if (!useTemplate && !useSurvey && pathname) {
        if (pathname.includes('/surveys/edit/')) {
            useSurvey = true;
        } else if (pathname.includes('/surveys/new/create')) {
            useTemplate = true;
        }
    }

    try {
        const persist = async api => {
            const res = await api(resArr[index]);
            const ok = res?.status_code === 200;
            if (ok) {
                item.body = nextBody;
            }
            return ok;
        };
        if (useTemplate) {
            return persist(timesaveTemplateQuestionApi);
        }
        if (useSurvey) {
            return persist(timesaveSurveryQuestionApi);
        }
        console.warn('题干保存：无法识别保存通道', {
            route,
            pathname,
            id: locationState?.id,
        });
        return false;
    } catch (e) {
        console.error('题干保存请求异常', e);
        return false;
    }
}
